import * as React from "react";

import {
  convertNoticeFiltersToFrameworkFilters,
  frameworkDetailsTarget,
} from "components/framework/utils";
import { NoticeFilters } from "components/notices/utils";
import CentredSpinner from "lib/core_components/CentredSpinner";
import { EllipsisTooltipRouterLink } from "lib/core_components/EllipsisTooltip";
import { useFrameworkUrlInformation } from "lib/hooks/api/frameworks/useFrameworkUrlInformation";
import { useCheckSubscription } from "lib/providers/ProHelper";
import { FrameworkProcessType } from "lib/types/graphQLEnums";

import css from "./FrameworkCell.module.scss";

type Props = {
  processType: FrameworkProcessType;
  frameworkId: string;
  frameworkName?: string;
  filters?: NoticeFilters;
};
export function FrameworkCell({
  processType,
  frameworkId,
  frameworkName,
  filters,
}: Props): JSX.Element | null {
  // TODO: Remove query below once the old notices table is removed
  const { data: framework, isLoading } = useFrameworkUrlInformation(frameworkId, {
    enabled: !frameworkName,
  });

  const { authorised, checkSubscription } = useCheckSubscription("FRAMEWORKS", {
    "Context source": "In-row",
  });

  const frameworkTitle = frameworkName ?? framework?.title;

  if (!frameworkName && isLoading) {
    return <CentredSpinner />;
  }

  return frameworkTitle ? (
    <div className={css.frameworkColumnContainer}>
      <EllipsisTooltipRouterLink
        fullText={frameworkTitle}
        linkProps={{
          ...frameworkDetailsTarget(frameworkId, convertNoticeFiltersToFrameworkFilters(filters)),
          className: css.titleText,
          onUnauthorisedClick: (e) => {
            e.stopPropagation();
            checkSubscription();
          },
          authorised: authorised,
        }}
        linkText={frameworkTitle}
        tooltipProps={{ contentMaxWidth: 350 }}
        containerClassname={css.frameworkTitle}
      />
      <span className={css.processTypeCell}>
        {processType === FrameworkProcessType.Framework ? "Framework agreement" : "Call-off"}
      </span>
    </div>
  ) : null;
}
